import { JSONSchema6 } from "json-schema";

const deliveryTrackerSchema: JSONSchema6 = {
    title: "DeliveryTracker",
    description: "Delivery Tracker lets you provide shipment tracking information to Amazon Pay so that Amazon Pay can notify buyers on Alexa when shipments are out for delivery and when they are delivered. This API is channel-agnostic. That means that anywhere you use Amazon Pay, you can use the Delivery Tracker API.  To test the Amazon Pay Delivery Tracker API, you will need an Amazon Pay “OrderReference ID” or “Charge Permission ID”.  This is the ID that is generated when an order is placed on a merchant’s website using Amazon Pay. You can use this ID along with the carrier code and tracking code of a supported carrier to trigger an Alexa Delivery Notification.",
    properties: {
        "payload": {
            type: "object",
            properties: {
                "chargePermissionId": {
                    type: "string"
                },
                "deliveryDetails": {
                    type: "object",
                    properties: {
                        "trackingNumber": {
                            type: "string"
                        },
                        "carrierCode": {
                            type: "string"
                        }
                    },
                    required: ["trackingNumber", "carrierCode"]
                }
            },
        required: ["chargePermissionId","deliveryDetails"]
        }
    },
    required: ["payload"]
}

export default deliveryTrackerSchema
